/* eslint max-classes-per-file: 0 */

import {
  FormsHandbook as Data,
  FormsHandbookCollection as Collection,
} from '@/typings/api/FormsHandbook'
import { FormsHandbookApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'


const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class FormsHandbookTransformerParams extends TransformerParams {
}

export class FormsHandbookAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new FormsHandbookTransformerParams();
}
